import request from '@utils/request';
// import urlHost from '@common/urlHost';

interface IGetVerificationCode {
  requestCode: string; // yoda request_code
}
// 接口文档 http://papi.sankuai.com/index/#/papi/project/195fa07e-3250-496a-904f-d392c5d0ec81?apiId=35ec5468-6e34-4980-9076-7b87a7466793
// 获取yoda request_code接口
export async function getVerificationCode(params): Promise<IGetVerificationCode> {
  const res: IGetVerificationCode = await request.post(`/api/official/user/sliding/verification/getCode`, params);
  return res;
}

// 接口文档 http://papi.sankuai.com/index/#/papi/project/195fa07e-3250-496a-904f-d392c5d0ec81?apiId=63456547-f573-4d0f-8680-626af743bd50
// 获取个保法文案
export async function getIndividualPrivacy() {
  const res = await request.post(`/api/official/user/individualPrivacy/getContent`);
  return res;
}

interface IGetPhoneBindStatus {
  // # UN_BIND(1, "未绑定"),    BIND(2, "绑定");
  bindStatus: number;
}
// 接口文档 http://papi.sankuai.com/index/#/papi/project/195fa07e-3250-496a-904f-d392c5d0ec81?apiId=2f309921-946a-440f-aef1-86ae97fcab34
// 查询微信登录手机号绑定情况
export async function getPhoneBindStatus(): Promise<IGetPhoneBindStatus> {
  // 切换到微信扫码登录时清除cookie
  document.cookie = 'unionLoginType=weixin;path=/;domain=meituan.com;max-age=43200;';
  const res: IGetPhoneBindStatus = await request.post(`/api/official/user/wechat/phone/bind/status`);
  return res;
}

// 获取当前服务器时间
export async function getNowTime(): Promise<Number> {
  const res: Number = await request.post(`/api/official/getNowTime`);
  return res;
}

// 获取简历作品集下载链接
export async function getDownFileUrlApi(fileId: string, resumeUnionId: string): Promise<string> {
  const res: string = await request.get(
    `/api/official/resume/attachment/download?fileId=${fileId}&resumeUnionId=${resumeUnionId}`,
  );
  return res;
}
